import { useModdyAdminOnlyQuery } from '../__generated__/apollo-hooks';

import { useAuthorization } from './use-authorization.hooks';
import { useCapabilities } from './use-capabilities.hooks';

type UseLlmConfigurationReturn = {
  isMissingConfiguration: boolean;
  showModdy: boolean;
  isLoadingConfiguration: boolean;
};

export const useLlmConfiguration = (): UseLlmConfigurationReturn => {
  const { moddy, loading: capabilitiesLoading } = useCapabilities();
  const { isAdministrator } = useAuthorization();
  const { data, loading: adminOnlyLoading } = useModdyAdminOnlyQuery({
    fetchPolicy: 'cache-first',
    skip: !moddy
  });

  const adminOnly = data?.currentUser.moddy.adminOnly ?? false;
  const loading = capabilitiesLoading || adminOnlyLoading;

  return {
    isMissingConfiguration: !loading && !moddy,
    showModdy: moddy && (!adminOnly || isAdministrator),
    isLoadingConfiguration: loading
  };
};
